import { useLocalSearchParams } from 'expo-router';

import { Messages } from '@/screens/messages';

export default function MessagesRoute() {
  const { connectionId } = useLocalSearchParams<{ connectionId: string }>();

  return <Messages connectionId={connectionId} />;
}
